import { render } from "./Select.vue?vue&type=template&id=5b7dd390&scoped=true"
import script from "./Select.vue?vue&type=script&lang=ts"
export * from "./Select.vue?vue&type=script&lang=ts"

import "./Select.vue?vue&type=style&index=0&id=5b7dd390&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5b7dd390"

export default script